import { useState, useEffect } from 'react';
import Web3 from 'web3';
import { fetchAssets } from '../services/assetService';
import { NETWORKS } from '../config/networkConfig';

export function useTokens(account) {
  const [tokens, setTokens] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (account) {
      fetchTokens(account);
    }
  }, [account]);

  const fetchTokens = async (account) => {
    setIsLoading(true);
    try {
      const assets = await fetchAssets(account);
      setTokens(assets);
    } catch (error) {
      console.error('Error fetching tokens:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return { tokens, isLoading };
}